import React from "react";

interface HeroProps {
  heroRef: React.RefObject<HTMLElement | null>;
  companyName: string;
}

const Hero: React.FC<HeroProps> = ({ heroRef, companyName }) => {
  return (
    <section ref={heroRef} className="w-full min-h-[85vh] flex flex-col items-center justify-center px-6 lg:px-12 pt-32 pb-20 relative overflow-hidden bg-gradient-to-b from-blue-50/50 to-white">
      <div className="container max-w-7xl relative z-10 flex flex-col items-center text-center">

        <div className="flex flex-col items-center gap-4 mb-12">
          {/* Crisp Trust Badge */}
          <div className="flex items-center gap-3 px-5 py-2 bg-white border border-blue-100 shadow-sm rounded-full">
            <div className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse" />
            <span className="text-xs font-bold tracking-widest text-text-secondary uppercase">{companyName} is a Registered NBFC</span>
          </div>
        </div>

        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tight mb-8 text-text-primary">
          Trusted Lending, <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">Simplified.</span>
        </h1>

        <p className="text-lg md:text-xl text-text-secondary max-w-3xl leading-relaxed font-medium mb-12">
          {companyName} is an RBI-registered NBFC delivering fast, transparent loans — personal, business, and vehicle — with no hidden charges and no fintech games.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center w-full sm:w-auto">
          <a
            href="/#services"
            className="w-full sm:w-auto px-10 py-4 bg-primary text-white font-bold text-lg rounded-full transition-all duration-300 hover:bg-primary-hover shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            Explore Loan Products
          </a>
          <a
            href="/loan-calculator"
            className="w-full sm:w-auto px-10 py-4 bg-white border border-gray-200 text-text-primary font-bold text-lg rounded-full hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm hover:shadow-md"
          >
            Check Your EMI
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
